module.exports = __webpack_public_path__ + "img/05.bab883d1.webp";